<script setup lang="ts">
import { computed } from '#imports';

const props = withDefaults(defineProps<{
  padding?: boolean;
}>(), {
  padding: true,
});

const classView = computed(() => {
  const result = [];
  
  if (props.padding) {
    result.push('_padding');
  }
  
  return result;
});
</script>

<template lang="pug">
ul.ui-list(
  v-if="$slots.default"
  :class="classView"
)
  slot
</template>

<style lang="scss" scoped>
.ui-list {
  margin: 0;
  padding: 0;

  &._padding {
    padding: 8px 0;
  }
}
</style>
